export default class ReferralFormChunk {
  constructor() {
    /* Load Referral form popin's JS */
    import(
      /* webpackPrefetch: true */
      /* webpackChunkName: 'prefetch-referralForm' */
      '../../../components/PopinReferral/PopinReferral'
    ).then(({ default: PopinReferral }) => {
      const referralForm: HTMLInputElement =
        document.querySelector('.js-enabledPopin');

      if (referralForm) {
        new PopinReferral();
      }
    });
  }
}
